<template>
  <div>
    <div flex v-for="(item, index) in optionsList" :key="index" class="option-item  item-answer" :class="isCloze?'isCloze':''">
      <div v-if="showTitle" style="margin-right: 2px; padding: 8px 0" class="questionSeq">
        <!-- {{ item.title }} -->
        {{ serialNumber[index] }}

      </div>
      <bc-view-common flex-box="1" :border="false" :content="item.content" :fileInfo="item.fileInfo"></bc-view-common>
    </div>
  </div>
</template>

<script>
export default {
  name: "bc-view-option",
  props: {
    option: {
      type: [String, Array, Object],
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    isCloze: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionsList: [],
      serialNumber: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  watch: {
    option: {
      handler(val) {
        console.log(val, '填空题');
        // if (typeof val == "object") return;
        try {
          if (Array.isArray(val)) {
            this.optionsList = val.map(function (item) {
              return typeof item == "object" ? item : JSON.parse(item);
            });
            console.log(this.optionsList);
          } else {
            this.optionsList = JSON.parse(val);
          }
        } catch (err) {
          this.optionsList = [];
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.option-item+.option-item {
  margin-top: 16px;
}

.option-item {
  background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  .questionSeq{
    min-width: auto;
    line-height: 24px;
  }

  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
  }
}
.isCloze{
  margin-bottom: 10px;
}
.isCloze:last-child{
  margin-bottom: 0;
}
</style>
